import { BusinessProVisitorCatalogLoggedOut } from '@fiverr-private/header';

export default BusinessProVisitorCatalogLoggedOut;
